import { AbstractAccessorService } from "@core/data-access";
import type { IDataAccessor } from "@core/data-access";
import { IResponse } from "@core/data-access/model";
import { getParamsObjType, ICartRestService } from "./cart-rest";
import { ICartData } from "../model/domain/ICartData";
import { ICartParams } from "../model/domain/ICartParams";
import { IUpdateCartParams } from "../model/domain/IUpdateCartParams";
import { ITotalPrice } from "../model/domain/ITotalPrice";
import { IAuthorizedPageObjectTreeService } from "../../basic/page/authorized/authorized-page-object-tree";
import { ICartQty } from "../model/domain/ICartQty";
import { ICartItem } from "../model/domain/ICartItem";
import { IParamCartItem } from "../model/domain/offers/IParamCartItem";
import { IBillingOffersParam } from "../model/domain/offers/IBillingOffersParam";
import { IBIllingOffers } from "../model/domain/offers/IBillingOffers";
import { IDiscountsCartItem } from "../model/domain/IDiscountsCartItem";


export class CartRestService extends AbstractAccessorService<ICartData> implements ICartRestService {
    public readonly $name: string = "cartRestService";

    private readonly OBJECT_TREE: IAuthorizedPageObjectTreeService;

    public static readonly $inject: string[] = ["$accessor", "$objectTree"];

    constructor(public $accessor: IDataAccessor<ICartData>, $objectTree: IAuthorizedPageObjectTreeService) {
        super();
        this.OBJECT_TREE = $objectTree;
    }


    /************************ Chore ************************* */
    // get替换getCart();
    /**
     * @description 获取购物车数据
     */
    public get(): angular.IPromise<IResponse<ICartData>> {
        if (this.OBJECT_TREE.isAnonymous()) {
            return this.$accessor<ICartData, {}, string>("userCartRestService", "get",);
        } else {
            return this.$accessor<ICartData, {}, string>("partnerCartRestService", "get");
        }
    }


    /**
     * @description 更新购物车项
     */
    public updateItem(shoppingCartItemId: string, updateParams: ICartParams): angular.IPromise<IResponse<ICartItem>> {

        let requestParams: IUpdateCartParams = {
            shoppingCartItemId: shoppingCartItemId
        };

        angular.extend(requestParams, updateParams);
        let parameter: { data: any, headers?: any } = {
            data: requestParams
        }
        if (this.OBJECT_TREE.isAnonymous()) {
            return this.$accessor<ICartItem, {}, string>("userCartRestService", "updateItem", parameter);
        } else {
            return this.$accessor<ICartItem, {}, string>("partnerCartRestService", "updateItem", parameter);
        }
    }
    /**
     * @description 批量删除购物车项
     */
    public multiDelete(itemIds: Array<string>): angular.IPromise<IResponse<boolean>> {
        if (this.OBJECT_TREE.isAnonymous()) {
            // 匿名用户购物车批量删除
            return this.$accessor<any, Array<string>, string>("userCartRestService", "multiDelete", {
                data: itemIds
            });
        } else {
            // partner购物车
            return this.$accessor<any, Array<string>, string>("partnerCartRestService", "multiDelete", {
                data: itemIds
            });
        }

    }
    /**
     * @description 删除购物车项
     */
    public deleteCartItem(shoppingCartItemId: string): angular.IPromise<IResponse<boolean>> {
        if (this.OBJECT_TREE.isAnonymous()) {
            // 匿名用户购物车批量删除
            return this.$accessor<any, {}, string>("userCartRestService", "deleteCartItem", {
                parameter: {
                    shoppingCartItemId: shoppingCartItemId
                }
            });
        } else {
            // partner购物车
            return this.$accessor<any, {}, string>("partnerCartRestService", "deleteCartItem", {
                parameter: {
                    shoppingCartItemId: shoppingCartItemId
                }
            });
        }
    }
    /**
     * @description 计算结算总价
     */
    public totalPrice(selectedList: string): angular.IPromise<IResponse<ITotalPrice>> {
        if (this.OBJECT_TREE.isAnonymous()) {
            // 匿名用户购物车批量删除
            return this.$accessor<ITotalPrice, {}, string>("userCartRestService", "totalPrice", {
                parameter: {
                    itemIds: selectedList
                }
            });
        } else {
            // partner购物车
            return this.$accessor<ITotalPrice, {}, string>("partnerCartRestService", "totalPrice", {
                parameter: {
                    itemIds: selectedList
                }
            });
        }
    }
    /**
     * @description 添加至购物车
     */
    public addToCart(cartParams: qpmn.cart.model.domain.ICartParams | Array<qpmn.cart.model.domain.ICartParams>): angular.IPromise<IResponse<boolean | Array<qpmn.cart.model.domain.ICartParams>>> {
        if (this.OBJECT_TREE.isAnonymous()) {
            // 匿名用户购物车批量删除
            return this.$accessor<any, {}, string>("userCartRestService", "addToCart", {
                data: cartParams
            });
        } else {
            // partner购物车
            const storeProductData = Array.isArray(cartParams) ? { storeProducts: cartParams } : cartParams;
            return this.$accessor<any, {} | ICartParams, string>("partnerCartRestService", "addToCart", {
                data: storeProductData
            });
        }
    }

    /**
     * @description 合并购物车
     */
    public mergeCart(anonymousUserId: number): angular.IPromise<IResponse<boolean>> {
        if (this.OBJECT_TREE.isAnonymous()) {
            // 匿名用户购物车批量删除
            return this.$accessor<any, {}, string>("userCartRestService", "mergeCart", {
                parameter: {
                    anonymousUserId: anonymousUserId
                }
            });
        } else {
            // partner购物车
            return this.$accessor<any, {}, string>("partnerCartRestService", "mergeCart", {
                parameter: {
                    anonymousUserId: anonymousUserId
                }
            });
        }
    }
    /**
     * @description 获取单个购物车项
     */
    public getItem(shoppingCartItemId: string): angular.IPromise<IResponse<any>> {
        if (this.OBJECT_TREE.isAnonymous()) {
            // 匿名用户购物车批量删除
            return this.$accessor<any, {}, string>("userCartRestService", "getItem", {
                parameter: {
                    shoppingCartItemId: shoppingCartItemId
                }
            });
        } else {
            // partner购物车
            return this.$accessor<any, {}, string>("partnerCartRestService", "getItem", {
                parameter: {
                    shoppingCartItemId: shoppingCartItemId
                }
            });
        }
    }
    /**
     * @description 批量获取购物车项
     */
    public getMultiItems(itemIds: string): angular.IPromise<IResponse<any>> {
        if (this.OBJECT_TREE.isAnonymous()) {
            // 匿名用户购物车批量删除
            return this.$accessor<any, {}, string>("userCartRestService", "getMultiItems", {
                parameter: {
                    itemIds: itemIds
                }
            });
        } else {
            // partner购物车
            return this.$accessor<any, {}, string>("partnerCartRestService", "getMultiItems", {
                parameter: {
                    itemIds: itemIds
                }
            });
        }
    }
    /**
     * @description 批量获取特定地区购物车项信息
     */
    public getSpecificMultiItems(itemIds: string, countryCode: string): angular.IPromise<IResponse<Array<ICartItem>>> {
        return this.$accessor<Array<ICartItem>, {}, string>("partnerCartRestService", "getSpecificMultiItems", {
            parameter: {
                itemIds: itemIds,
                "saleRegions-country": countryCode
            }
        });
    }

    /**
      * @description: 批量购物车项信息--优惠信息（订单优惠/优惠卷优惠）
      * @param itemIds
      * @param couponCodes
      * @return {*}
      */
    public getDiscountsMultiItems(itemIds: Array<string>, couponCodes: Array<string>, currencyCode: string): angular.IPromise<IResponse<Array<IDiscountsCartItem>>> {
        return this.$accessor<Array<IDiscountsCartItem>, {}, string>("userCartRestService", "getDiscountsMultiItems", {
            data: {
                cartItems: itemIds,
                couponCodes: couponCodes,
                currencyCode: currencyCode
            }
        });
    }
    /**
     * @description 生成预拼单项
     */
    public cartPreBulkOrder(ids: Array<string>, addressInstance: qpmn.bulkOrder.model.domain.AddressInstance): angular.IPromise<IResponse<boolean>> {
        return this.$accessor<any, {}, string>("partnerCartRestService", "cartPreBulkOrder", {
            parameter: {
                ids: ids,
                addressInstance: addressInstance
            }
        });
    }

    /**
     * @description 获取购物车数量
     */
    public totalQty(): angular.IPromise<IResponse<ICartQty>> {
        if (this.OBJECT_TREE.isAnonymous()) {
            // 获取匿名用户购物车数量
            return this.$accessor<ICartQty, {}, string>("userCartRestService", "totalQty");
        } else {
            // 获取实名用户购物车数量
            return this.$accessor<ICartQty, {}, string>("partnerCartRestService", "totalQty");
        }
    }

    /**
     * @description 检查购物车项结算状态
     */
    public checkShoppingLineItemsSettledStatus(ShoppingLineItemIds: Array<string>): angular.IPromise<IResponse<{ [itemId: string]: boolean }>> {
        // true表示item未结算，购物车存在该购物车项
        // false表示已经结算过
        return this.$accessor<any, {}, string>("partnerCartRestService", "checkShoppingLineItemsSettledStatus", {
            data: ShoppingLineItemIds
        });
    }

    /**
     * @description 获取结算优惠信息
     * @param offersParam
     * */
    public getBillingOffers(offersParam: IBillingOffersParam): angular.IPromise<IResponse<IBIllingOffers>> {
        return this.$accessor<IBIllingOffers, {}, string>("partnerCartRestService", "getBillingOffers", {
            data: offersParam
        });
    }



}